<template lang="pug">
.toggle-menu(md-theme="white" ref="menu" v-click-outside="hide")
  md-button.md-icon-button.md-dense(@click="toggleContent"): md-icon {{ icon }}
  .menu-content.md-elevation-1(ref="menu_content" v-if="visible")
    slot
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'toggle-menu',
  props: [
    'icon'
  ],
  directives: {
    ClickOutside
  },
  created() {
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    getCoords(elem) {
      var box = elem.getBoundingClientRect()

      var body = document.body
      var docEl = document.documentElement

      var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop
      var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft

      var clientTop = docEl.clientTop || body.clientTop || 0
      var clientLeft = docEl.clientLeft || body.clientLeft || 0
      var clientRight = docEl.clientRight || body.clientRight || 0

      var top  = box.top +  scrollTop - clientTop
      var left = box.left + scrollLeft - clientLeft

      return { top: Math.round(top), left: Math.round(left) }
    },
    toggleContent() {
      this.visible = !this.visible
      if (this.visible) {
        this.$nextTick(() => {
          this.$refs.menu_content.removeAttribute('style')
          let offset = this.getCoords(this.$refs.menu)
          let windowWidth = window.innerWidth
          let contentWidth = this.$refs.menu_content.offsetWidth
          let menuWidth = this.$refs.menu.offsetWidth
          if (offset.left + contentWidth > windowWidth) {
            let rightOffset = windowWidth - offset.left - menuWidth
            this.$refs.menu_content.style.right = rightOffset + 'px'
          } else {
            let leftOffset = offset.left + (menuWidth / 2) - (contentWidth / 2)
            this.$refs.menu_content.style.left = leftOffset + 'px'
          }
        })
      }
    },
    hide() {
      this.visible = false
    }
  }
}
</script>

<style scoped lang="sass">
.toggle-menu
  position: relative
  .menu-content
    display: flex
    position: fixed
    background: #fff
    color: #000 
    z-index: 10
    padding: 10px
    min-width: 200px
    box-sizing: border-box
    .col + .col
      margin-left: 15px
    .heading
      font-weight: 600
      margin-bottom: 6px
    .option
      cursor: pointer
      padding: 3px 6px
      border-radius: 13px
      &.active
        background: rgba(0, 0, 0, .05)
  .md-checkbox, .md-radio
    margin: 0
  .md-button
    margin: 0
</style>


// WEBPACK FOOTER //
// ToggleMenu.vue?9b4f9a28